<template>
	<ValidationObserver tag="form" ref="observer" @submit.prevent="handleSubmit()">
	    <p class="f-14 f-m-12 margin-0"><strong>Info Device</strong></p>
	    <div class="row">
	        <div class="col">
				<div class="form-group mb-0">
					<label class="form-label">Merek / Tipe device (handphone)</label>
					<ValidationProvider name="Merek / Tipe device" rules="required" v-slot="{ errors }">
						<input type="text" v-model="model.merk" class="form-control" :class="{ 'error': errors[0] }" placeholder="Masukkan merek / Tipe device">   
						<small style="color: red !important;" v-if="errors[0]">{{ errors[0] }}</small>
					</ValidationProvider>
					</div>
				<div class="form-group">
					<label class="form-label mt-1">Nomor telepon</label>
					<ValidationProvider name="Nomor telepon" rules="required|numeric" v-slot="{ errors }">
						<input type="text" v-model="model.phone_number" class="form-control" :class="{ 'error': errors[0] }" placeholder="Masukkan nomor telepon">   
						<small style="color: red !important;" v-if="errors[0]">{{ errors[0] }}</small>
					</ValidationProvider>
				</div>
	        </div>
	        <div class="col">
	            <div class="form-group">
	                <label class="form-label">IMEI</label>
	                <ValidationProvider name="IMEI" rules="required|min:15|max:15|numeric" v-slot="{ errors }">
				        <input type="text" v-model="model.imei" class="form-control" :class="{ 'error': errors[0] }" placeholder="Masukkan nomor imei handphone anda">   
						<small style="color: red !important;" v-if="errors[0]">IMEI Tidak Benar (Masukan 15 Digit Nomor IMEI)</small>
					</ValidationProvider>
	            </div>
	        </div>  
	    </div>      
	    <hr>

	    <button type="submit" class="float-right btn btn-primary col-2 mb-3 w-m-1-2 margin-5 pd-10-20">Simpan</button>
	</ValidationObserver>
</template>

<script>
export default {
	name: 'Form',
	data() {
		return {
			selectedCountries: [],
			countries: [],
			isLoading: false,
			model: {
				merk: null,
				phone_number: null,
				imei: null,
				id_user: 1
			}
		}
	},
	beforeMount() {
		let _ = this

		if ( _.$route.params.id ) {
			_.getData()
		}
	},
	methods: {
		create() {
			let _ = this
			let data = _.model
			_.axios.post('device', data )
				.then(resp => {
					if ( resp.data.status ) {
						_.$router.push({
							name: 'DeviceIndex',
							params: {
								status: 'insert'
							}
						})
					}
				})
				.catch(err => {
					this.$toast.open({
						message: err.response.data.message,
						type: "error"
					})
				})
		},
		update() {
			let _ = this
			let update = {
				id: _.$route.params.id,
				..._.model
			}

			_.axios.patch('/device', update)
				.then(resp => {
					if ( resp.data.status ) {
						_.$router.push({
							name: 'DeviceIndex',
							params: {
								status: 'update'
							}
						})
					}
				})
				.catch(err => {
					this.$toast.open({
						message: err.response.data.message,
						type: "error"
					})
				})
		},
		getData() {
			let _ = this
			_.axios.get('/device?id=' + _.$route.params.id)
				.then(resp => {
					let getData = resp.data.data.rows
					_.model = {
						merk: getData.merk,
						phone_number: getData.phone_number,
						imei: getData.imei,
						id_user: 1
					}
				})
				.catch(err => {
					this.$toast.open({
						message: err.response.data.message,
						type: "error"
					})
				})
		},
		async handleSubmit(){
			let _ = this
			const isValid = await this.$refs.observer.validate()
			if (isValid) {
				if (_.$route.params.id){
					_.update()
				} else {
					_.create()
				}
			}
		}
	}
}
</script>